import {
    Assignment,
    Dashboard,
    DataUsage,
    Factory,
    Flag,
    Group,
    Inventory,
    Person,
    School,
    SettingsRemote,
    TrendingUp,
    Visibility
  } from '@mui/icons-material';

export const SSE_URL = '/notification/getNotificationCount';

export const iconMap: Record<string, React.ComponentType> = {
    // type icons
    Direct: Flag,
    UserGroup: Group,
    Watching: Visibility,
  
    // snake_case module keys
    inventory: Inventory,
    attendance: School,
    insights: TrendingUp,
    task: Assignment,
    Tasks: Assignment,
    data_break: DataUsage,
    users: Person,
    plant_configuration: Factory,
    remote_control: SettingsRemote,
    dashboard: Dashboard,
  
    // human-readable module names
    Inventory: Inventory,
    Attendence: School,
    Insights: TrendingUp,
    Task: Assignment,
    'Data Break': DataUsage,
    Users: Person,
    plants: Factory,
    Plants: Factory,
    'Remote Control': SettingsRemote,
    'Plant Configuration': Factory,
  };